import { APISettings } from "../../config/ApiSettings";
import { BaseAPI } from "./baseApi";
const baseUrl = new APISettings().getApiURL();

class FilingWorkflowHistoryApi<FilingWorkflowHistory> extends BaseAPI {
    public getAll: () => Promise<FilingWorkflowHistory[]> = async () => {
        return ((await BaseAPI.axios.get(`${baseUrl}/FilingWorkflowHistory`))).data.output;
    }

    public getByFilingId: (id: number) => Promise<FilingWorkflowHistory[]> = async (id: number) => {
        return ((await BaseAPI.axios.get(`${baseUrl}/FilingWorkflowHistory/GetByFilingId/${id}`))).data.output;
    }
}

export const filingWorkflowHistoryApi = new FilingWorkflowHistoryApi();